import includes from 'lodash/includes';

import { AwsException } from '../../api/common/utils/exceptions/AwsException';

const XmlContentTypes = ['application/xml', 'text/xml'];

async function parseAwsResponseError(
  response: Response
): Promise<AwsException | null> {
  if (response.ok) {
    return null;
  }

  const contentType = response.headers?.get('Content-Type') || '';

  if (!includes(XmlContentTypes, contentType)) {
    return null;
  }

  const text = await response.text();
  const parser = new DOMParser();

  const xml = parser.parseFromString(text, 'application/xml');
  const code = xml.querySelector('Code')?.textContent;
  const storageClass = xml.querySelector('StorageClass')?.textContent;
  const message = xml.querySelector('Message')?.textContent;

  return new AwsException(
    response.status,
    response.statusText,
    code,
    message,
    storageClass
  );
}

export default parseAwsResponseError;
